<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import { Button, Icon } from '@rapoo/element'
  import { useUpdateStore } from '@/stores'
  import UpdateCheckDialog from './updateDialog/index.vue'
  import UpdateLogDialog from './updateDialog/UpdateLogDialog.vue'

  const showDialog = ref(false)
  const showUpdateLogDialog = ref(false)
  const isLoading = ref(false)

  const updateStore = useUpdateStore()
  const { status } = storeToRefs(updateStore)

  const isUptoDate = computed(() => status.value === 'undownload')

  const handleCheckUpdate = async () => {
    isLoading.value = true
    await updateStore.checkAndDownload()
    isLoading.value = false
    showDialog.value = true
  }

  const route = useRoute()
  onMounted(() => {
    if (route.query.action === 'checkUpdate') {
      handleCheckUpdate()
    }
  })

  const version = ref('0.0.0')
  onMounted(async () => {
    version.value = (await window.electronAPI?.getAppVersion()) ?? '0.0.0'
  })
</script>

<template>
  <div v-loading="isLoading" class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-1 h-9 text-black-white text-l-medium">
        <Icon icon="Technology-Wireframe-Update" class="size-6" />
        <span>{{ $t('setting.about.update.title') }}</span>
      </div>

      <div class="flex items-center gap-2">
        <Button size="sm" color="black" class="h-8" @click="showUpdateLogDialog = true">
          {{ $t('setting.about.update.relaseNotes') }}
        </Button>
        <div class="relative">
          <Button
            size="sm"
            color="black"
            class="h-8"
            :disabled="isUptoDate"
            @click="handleCheckUpdate"
          >
            {{
              isUptoDate
                ? $t('setting.about.update.latestVersion')
                : $t('setting.about.update.checkUpdatesButton')
            }}
          </Button>
          <div
            v-if="!isUptoDate"
            class="absolute top-0.5 right-0 w-2 h-2 rounded-full bg-brand-red"
          />
        </div>
      </div>
    </div>

    <div class="flex justify-between items-center">
      <span class="text-m-medium text-text-glass-default">
        {{ $t('setting.about.update.currentVersion', { version }) }}
      </span>
    </div>

    <UpdateCheckDialog v-model:open="showDialog" />
    <UpdateLogDialog v-model:open="showUpdateLogDialog" />
  </div>
</template>
